var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1985e1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.48,17h-12a.5.5,0,0,1-.5-.5V4.5a.5.5,0,0,1,.5-.5h12a.5.5,0,0,1,.5.5v12A.5.5,0,0,1,16.48,17ZM5,16H16V5H5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.5,9.5A.5.5,0,0,1,1,9V1.5A.5.5,0,0,1,1.5,1H9A.5.5,0,0,1,9,2H2V9A.5.5,0,0,1,1.5,9.5Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.77a54bbe1714dfc2ca9f843076f961a5.svg";
export { ForwardRef as ReactComponent };